if (!customElements.get('adev-recently-viewed-recorder')) {
	class AdevRecentlyViewedRecorder extends HTMLElement {
		constructor() {
			super();
			this.cookieKey = 'adev_recently_viewed';
			this.maxItems = 4;
		}

		connectedCallback() {
			if (this.isProductPage() && this.getProductHandle()) {
				this.updateRecentlyViewed();
			}
		}

		isProductPage() {
			return Theme && Theme.isProductPage;
		}

		getProductHandle() {
			return Theme && Theme.productHandle;
		}

		getCookie() {
			return window.Cookies ? window.Cookies.get(this.cookieKey) : null;
		}

		setCookie(value) {
			if (window.Cookies) {
				window.Cookies.set(this.cookieKey, JSON.stringify(value), { expires: 30, path: '/' });
			}
		}

		getRecentlyViewed() {
			const cookie = this.getCookie();
			if (!cookie) return [];
			try {
				const arr = JSON.parse(cookie);
				return Array.isArray(arr) ? arr : [];
			} catch {
				return [];
			}
		}

		updateRecentlyViewed() {
			const handle = this.getProductHandle();
			let viewed = this.getRecentlyViewed();
			viewed = viewed.filter(h => h !== handle);
			viewed.unshift(handle);
			if (viewed.length > this.maxItems) {
				viewed = viewed.slice(0, this.maxItems);
			}
			this.setCookie(viewed);
		}
	}

	customElements.define('adev-recently-viewed-recorder', AdevRecentlyViewedRecorder);
}
